export default "__VITE_ASSET__DfLAeqBg__"